// extracted by mini-css-extract-plugin
module.exports = {"trend":"JGTGl","up":"Q5grB","down":"_16TiQ","popover":"EUTPo","grid":"ghFoB","item":"LeMwp","title":"IK9b-","value":"gnTWV"};